<template>
  <div>
    <span class="iv-fc-65 iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-add-list" @click="expandParent('view', item)">
      查看详情
    </span>
    <span v-if="item.isShowFillOpinion" 
      class="iv-fc-65 iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-add-list" @click="expandParent('opinion', item)">
      最终意见
    </span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  inject: {
    expandParent: {
      default () {
        return function () {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .ivu-poptip-popper {
    left: auto !important;
    right: 1px;
    .ivu-poptip-arrow {
      margin-left: 38px !important;
    }
    .ivu-btn {
      padding: 0px 9px !important;
    }
  }
  /deep/ .ivu-poptip-confirm {
    display: inline-flex;
  }
</style>
